module.exports = __webpack_public_path__ + "static/img/download.ffaec4e4.png";